// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"afce871a","444":"b0b9f545","456":"d0852986","568":"26225ad0","810":"50940f00","864":"a6c25db6"}[chunkId] + ".chunk.css";
};